import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Button, CircularProgress, IconButton } from "@mui/material";
import { SubTitle, Title } from "../common";
import KenButton from "../../../Components/KenButton";
import OtpInput from "react-otp-input";
import Countdown from "react-countdown";
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { requestForOTP, requestOneTimeOtp } from "../api";
import { pad } from "../../../Utils/Helpers/applicationHelper";
import { COOL_DOWN_COUNT_IN_SECONDS } from "../../../Constants/constant";

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    minWidth: "500px",
    maxWidth: "500px",
    minHeight: "520px",
    "box-shadow": "0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)",
    "border-radius": "16px",
    padding: "48px 84px",
    [theme.breakpoints.down("sm")]: {
      boxShadow: "none",
      padding: "8px",
      minWidth: "360px",
      maxWidth: "360px",
    },
  },
  title: {
    marginBottom: "16px",
  },
  subTitle: {
    marginBottom: "16px",
    textAlign: "left",
    "line-height": "150% !important",
  },
  mobileLabel: {
    "font-style": "normal",
    "font-weight": "400",
    "font-size": "14px",
    "line-height": "100%",
    "text-transform": "capitalize",
    color: "#505F79",
  },
  verify: {
    width: "100%",
    height: "48px",
    marginBottom: "40px",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    color: "#092682 !important",
    background: "#f6c445 !important",
    fontFamily: "Poppins,sans-serif",
  },
  headerContent: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 20px 0px",
    },
  },
  containerStyle: {
    color: "red",
    "& div": {
      width: "70px",
      border: "0",
      borderBottom: "1px solid #A8AFBC;",
      margin: "16px 8px",
    },
  },
  inputStyle: {
    width: "100% !important",
    border: "0",
    height: "35px",

    "&:focus-visible": {
      outline: "none",
    },
  },
  resend: {
    "font-weight": "400",
    "font-size": "14px",
    "line-height": "100%",
    color: "#52C15A",
  },
}));

export default function Verify(props) {
  const { setOtp, otp = "", handleResendOtp } = props;
  const classes = useStyles();
  const countDownRef = useRef();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [countDown, setCountDown] = useState(Date.now() + COOL_DOWN_COUNT_IN_SECONDS * 1000);

  const handleChange = (otp) => {
    setOtp(otp);
  };

  const handleResend = async () => {
    setLoading(true);
    const res = await handleResendOtp();

    if (res?.success) {
      setLoading(false);
      // alert(`OTP is: ${res?.otp ? res?.otp : res?.OTP}`);
      setCountDown(Date.now() + COOL_DOWN_COUNT_IN_SECONDS * 1000);
    }
  };

  // Renderer callback with condition
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return (
        <Button
          className={classes.resend}
          onClick={async (e) => {
            await handleResend();
          }}
        >
          Resend
        </Button>
      );
    } else {
      // Render a countdown
      return (
        <span>
          {pad(minutes, 2)}:{pad(seconds, 2)}
        </span>
      );
    }
  };

  useEffect(() => {
    if (countDownRef) {
      countDownRef.current.api.start();
    }
  }, [countDown]);

  return (
    <Box
      component={"form"}
      onSubmit={(e) => {
        e.preventDefault();
        props.onVerify({ otp });
      }}
      className={classes.contentWrapper}
      display={"flex"}
      flexDirection="column"
      justifyContent={"flex-start"}
      alignItems="flex-start"
      position={"relative"}
    >
      <Box className={classes.headerContent}>
        <IconButton
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIcon sx={{ color: "black" }} />
        </IconButton>
        <Title text={props.title} />
        <div />
      </Box>
      <SubTitle className={classes.subTitle} text={props.subTitle} />
      {props.children}
      <OtpInput isInputNum value={otp} onChange={handleChange} numInputs={4} containerStyle={classes.containerStyle} inputStyle={classes.inputStyle} />
      <Box display={"flex"} justifyContent="center" alignItems={"center"} my={4} width="100%">
        <Countdown ref={countDownRef} date={countDown} renderer={renderer}></Countdown>
      </Box>
      <KenButton variant="roundedButton" buttonClass={classes.verify} type="submit" disabled={loading || (otp || "").length < 4}>
        {props.submitText ? props.submitText : "Verify"}
      </KenButton>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            position: "absolute",
            top: "50%",
            left: "49%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
    </Box>
  );
}
